// removed by extract-text-webpack-plugin
module.exports = {"root":"TabNav__root__jmi6S","tab":"TabNav__tab__39eoi","link":"TabNav__link__1PgdT","selectedLink":"TabNav__selectedLink__2d9yw","disabled":"TabNav__disabled__2I5dd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TabNav/TabNav.css
// module id = 2124
// module chunks = 0